import React from "react";
import SearchInput from "./SearchInput";

const UpdateSubdomain = ({ merchantSubdomain, merchantRedirect, onChange }) => (
  <>
    <SearchInput
      type="text"
      placeholder="new subdomain"
      name="merchantSubdomain"
      value={merchantSubdomain}
      onChange={onChange}
    />
    <div className="mt-5 pl-5 py-2 flex gap-4">
      <input
        id="mission_control_merchant_redirect"
        type="checkbox"
        name="merchantRedirect"
        label="Set up a redirect?"
        checked={merchantRedirect}
        onChange={e => onChange(e, e.target.checked)}
      />
      <label htmlFor="mission_control_merchant_redirect">
        Set up a redirect?
      </label>
    </div>
    <p className="mt-4 ml-4 font-medium text-xs">
      <span className="text-red-600">Warning:</span> {}
      this modifies the merchant record. You will need to reload
      the page for the Returns Portal menu item to work if you have
      not asked for a redirect to be set up.
    </p>
  </>
);

export default UpdateSubdomain;
